var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.33333 6.00001H22.6667M22.6667 6.00001L19.5555 1.79996M22.6667 6.00001C22.6667 6.00001 20.7705 8.55976 19.5555 10.2","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"viewBox":"0 0 24 12","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
